var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBottle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 20,
    viewBox: "0 0 8 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.42105 20H1.26316C0.631579 20 0 19.3684 0 18.7368V9.89474C0 8.63158 0.526316 7.78947 1.05263 7.05263C1.47368 6.31579 1.89474 5.57895 2.10526 4.52632C2.42105 2.21053 2.42105 0.526316 2.42105 0.526316V0H5.57895V0.526316C5.57895 0.526316 5.57895 2.21053 5.89474 4.52632C6 5.57895 6.52632 6.31579 6.94737 7.05263C7.47368 7.89474 8 8.73684 8 9.89474V18.5263C7.89474 19.3684 7.1579 20 6.42105 20ZM3.36842 1.05263C3.36842 1.68421 3.26316 3.05263 3.05263 4.63158C2.84211 5.89474 2.31579 6.73684 1.89474 7.57895C1.47368 8.31579 1.05263 8.94737 1.05263 9.89474V18.7368C1.05263 18.8421 1.15789 18.9474 1.26316 18.9474H6.31579C6.52632 18.9474 6.73684 18.7368 6.73684 18.5263V9.89474C6.73684 8.94737 6.31579 8.31579 5.89474 7.57895C5.47368 6.84211 4.84211 5.89474 4.73684 4.63158C4.52632 3.05263 4.42105 1.68421 4.42105 1.05263H3.36842Z",
    fill: "#666666"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottle);
export default __webpack_public_path__ + "static/media/bottle.049c2078c58ead060a3a333d539f77ef.svg";
export { ForwardRef as ReactComponent };